import I18n from 'i18n-js/index.js.erb'

document.addEventListener("turbolinks:load", () => {
    I18n.defaultLocale = "fr";
    I18n.locale = $('#locale').data()['locale'];

    "use strict"; // Start of use strict
    if ($('#program-sessions-datatable').length) {
        var language = {
        "processing": I18n.t("js.sessions_datatable.processing"),
        "lengthMenu": "_MENU_",
        "info": I18n.t("js.sessions_datatable.info", { start: "_START_", end: "_END_", total: "_TOTAL_" }),
        "infoEmpty": I18n.t("js.sessions_datatable.infoEmpty"),
        "infoFiltered": I18n.t("js.sessions_datatable.infoFiltered", { max: "_MAX_"}),
        "infoPostFix": "",
        "loadingRecords": I18n.t("js.sessions_datatable.loadingRecords"),
        "zeroRecords": I18n.t("js.sessions_datatable.zeroRecords"),
        "emptyTable": I18n.t("js.sessions_datatable.emptyTable"),
        "select": {
            "rows": "<br> %d " + I18n.t("js.sessions_datatable.select")
        }
        };

        var columns = [
            {
                "data": "mentor"
            },
            {
                "data": "mentee"
            },
            {
                "data": "created_at"
            },
            {
                "data": "meetings"
            }
        ];

        var sessionsTable = $('#program-sessions-datatable').DataTable({
            "processing": true,
            "serverSide": true,
            "searching": true,
            "dom": 'Blirtp',
            "ajax": {
            "url": $('#program-sessions-datatable').data('source')
            },
            "pagingType": "simple_numbers",
            "columns": columns,
            "language": language
        });

        // Search
        $('#program-sessions-search').on('keyup', function() {
            sessionsTable.search($(this).val()).draw() ;
        })
    }
})

